"use client";
import Paragraph from "antd/lib/typography/Paragraph";
import React from "react";

const DisplayBio = ({ bio }: { bio: string }) => {
  return (
    <Paragraph
      style={{ margin: 0 }}
      ellipsis={{
        rows: 2,
        expandable: true,
        // symbol: "more",
        symbol: <span className="has-text-dark">[more]</span>,
        defaultExpanded: false,
      }}
    >
      {bio}
    </Paragraph>
  );
};

export default DisplayBio;
